export function checkEva() {
    var _a, _b, _c;
    return (_c = (_b = (_a = document.querySelector("meta[name='version']")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) === null || _b === void 0 ? void 0 : _b.startsWith("EVA")) !== null && _c !== void 0 ? _c : false;
}
//# sourceMappingURL=checkEva.js.map